export default __webpack_public_path__ + "static/media/call2.c0ab83fa.gif";